module.exports = __webpack_public_path__ + "img/Kstars.bd2eb13a.jpg";